import React, {Component} from "react";
import "./GridView.css";
import {formatFileSize} from "../utils/Utils";

export class GridView extends Component {

    // props.title = "List title"
    // props.items = []
    // props.totalSize = 999
    // props.loading = true/false
    // props.error = true/false
    // props.onClickUrl = (path) => url
    // props.onLoadMore = (offset) => loads more data

    state = {
        trail: 0
    };

    componentDidMount() {
        window.addEventListener("resize", this.updateTrails);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateTrails);
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.items != this.props.items) {
            this.updateTrails();
        }
    }

    updateTrails = () => {
        this.setState({trail: this.calculateTrail()});
    };

    calculateTrail = () => {
        const minTile = 100; // px
        const padding = 10; // px
        const clientWidth = document.getElementById("root").clientWidth;
        const cols = Math.trunc((clientWidth - padding) / (minTile + padding));
        const count = this.props.items.length + (this.props.items.length < this.props.totalSize ? 1 : 0);
        return (cols - (count % cols)) % cols;
    };

    render() {
        if (this.props.error) {
            return <>
                <div className="category-header">{this.props.title}</div>
                <div className="error ml-3 mr-3">Failed to load</div>
            </>;
        }

        if (this.props.items.length === 0) {
            if (this.props.loading) {
                return <>
                    <div className="category-header">{this.props.title}</div>
                    <div className="muted pl-3 pr-3 pb-3">Loading...</div>
                </>;
            } else {
                return null;
            }
        }

        const showLoadMore = this.props.items.length < this.props.totalSize;

        return <>
            <div className="category-header">{this.props.title} ({this.props.totalSize})</div>
            <div className="category-content block-details">
                {this.props.items.map(item =>
                    <div className="thumb" key={item.id}>
                        <a href={this.props.onClickUrl(item)}>
                            <img src={item.urlThumbnail} className="thumb-image" alt=""
                                 title={item.fileName + "\n" + formatFileSize(item.size) + "\n" + item.timestamp + "\n" + item.contentType}
                                 onMouseOver={e => e.target.src = item.urlThumbnailAnimated || item.urlThumbnail}
                                 onMouseOut={e => e.target.src = item.urlThumbnail}
                            />
                        </a>
                    </div>)}

                {showLoadMore && <div className="thumb" key="more" onClick={this.props.onLoadMore}>
                    <div className="thumb-image grid-load-more">
                        ...
                    </div>
                </div>}

                {[...Array(this.state.trail).keys()].map(i => <div className="thumb" key={"trail-" + i}>
                    <div className="thumb-image"/>
                </div>)}
            </div>
        </>;
    }
}
